import { ErrorMessage } from '@hookform/error-message';
import { CreatableSelect as CreatableSelectKey } from 'chakra-react-select';
import React from 'react';
import { useController } from 'react-hook-form';
import { FormControl, FormLabel, FormWarning } from '../..';
export function CreatableSelect({ name, options, control, rules, disableErrorMessage, labelText, ...rest }) {
    const { field: { onChange, onBlur, value, ref }, formState: { errors } } = useController({
        control,
        name,
        rules: rules
    });
    return (React.createElement(FormControl, null,
        labelText && (React.createElement(FormLabel, { htmlFor: name, id: name + 'label', key: name + 'label' }, labelText)),
        React.createElement(CreatableSelectKey, { isMulti: true, name: name, ref: ref, onChange: onChange, onBlur: onBlur, value: value, closeMenuOnSelect: false, options: options, errors: [0, 1], styles: {
                menuPortal: (provided) => ({ ...provided, zIndex: 100 })
            }, ...rest, "aria-labelledby": name + 'label' }),
        !disableErrorMessage && errors[name] && (React.createElement(FormWarning, null,
            React.createElement(ErrorMessage, { errors: errors, name: name, render: ({ messages }) => messages && Object.entries(messages).map(([type, message]) => React.createElement("p", { key: type }, message)) })))));
}
